import _ from 'lodash';
import { validateMandatoryAttribute } from '../../HelperMethods/FormUtils';
import {
  PREFERRED_LOCATION_TYPE,
  PICKLIST_SKILLLEVEL_NAME,
  PICKLIST_ACLQUALIFIED_NAME,
  PICKLIST_VENDOR_NAME,
  PICKLIST_CERTIFICATES_NAME,
  PRIORITY_INCREMENT_PICKLIST,
  TASK_TYPE_GROUP,
  WATCHER_GROUP,
} from '../../HelperMethods/constants';
import { METADATA_ASSIGNEE_LIST, METADATA_ASSET_LIST } from '../common/form-preview/FormUtils';

export function validateAttributeObject(formValues, attributeObject, errors) {
  const { attributeName } = attributeObject;
  const attributeValue = _.get(formValues, attributeName);
  if (_.get(formValues, attributeName) && attributeObject.children && attributeObject.children.length > 0) {
    for (const childAttributeObj of attributeObject.children) {
      errors = validateAttributeObject(formValues, childAttributeObj, errors);
    }
  }
  if (attributeObject.isMandatory) {
    const validationObj = validateMandatoryAttribute(attributeObject, attributeValue);
    if (!validationObj.validation) {
      errors[attributeName] = validationObj.message;
      return errors;
    }
  }
  if (attributeObject.validations && attributeObject.validations.length > 0) {
    for (const validation of attributeObject.validations) {
      if (!validation.validateFunc({ formValues })) {
        errors[attributeName] = validation.message;
        break;
      }
    }
  }
  return errors;
}

export const optionInitialValue = { sortOrder: '', name: '', description: '', isInactive: false, code: '' };

export const PICKLIST_TYPE_OPTIONS = {
  STATIC: { key: 'static', value: 'static', text: 'Static' },
  METADATA: { key: 'metadata', value: 'metadata', text: 'Metadata' },
};

export const picklistInitialValue = {
  name: '',
  displayName: '',
  type: PICKLIST_TYPE_OPTIONS.STATIC.value,
  parentId: null,
  component_picklistOptions: [_.clone(optionInitialValue)],
};

export const PROTECTED_PICKLIST_NAMES = [
  PICKLIST_CERTIFICATES_NAME,
  PICKLIST_VENDOR_NAME,
  'ContractInfo',
  PICKLIST_ACLQUALIFIED_NAME,
  PICKLIST_SKILLLEVEL_NAME,
  PREFERRED_LOCATION_TYPE,
  PRIORITY_INCREMENT_PICKLIST,
  TASK_TYPE_GROUP,
  WATCHER_GROUP,
];
export const entityOptions = {
  Task: { key: 'task', value: 'task', text: 'Task' },
  TaskType: { key: 'tasktype', value: 'tasktype', text: 'Task Type' },
  Asset: { key: 'asset', value: 'asset', text: 'Asset' },
  Assignee: { key: 'assignee', value: 'assignee', text: 'Assignee' },
  WatcherGroup: { key: 'watchergroup', value: 'watchergroup', text: 'Watcher Group' },
};
export const attributeOptions = {
  [entityOptions.Task.value]: [METADATA_ASSIGNEE_LIST, METADATA_ASSET_LIST],
  [entityOptions.TaskType.value]: [{ key: 'name', value: 'name', text: 'Name' }],
  [entityOptions.Assignee.value]: [
    { key: 'userName', value: 'userName', text: 'Username' },
    {
      key: 'name',
      value: 'name',
      text: 'Name',
    },
  ],
  [entityOptions.Asset.value]: [
    {
      key: 'name',
      value: 'name',
      text: 'Name',
    },
    { key: 'type', value: 'type', text: 'type' },
    { key: 'subType', value: 'subType', text: 'subType' },
  ],
  [entityOptions.WatcherGroup.value]: [
    {
      key: 'name',
      value: 'name',
      text: 'Name',
    },
  ],
};

export function mapPicklistMappingDBEntityToFormEntity(picklistMappingDBEntity) {
  const picklistMappingFormEntity = {
    id: picklistMappingDBEntity.id,
    name: picklistMappingDBEntity.name ?? '',
    options: picklistMappingDBEntity.mappingTable ?? [],
    picklistIds: picklistMappingDBEntity.picklistIds ?? ['', ''],
    numberOfPicklists: picklistMappingDBEntity.picklistIds?.length || 2,
    tenantId: picklistMappingDBEntity.tenantId,
    optionsForm: {
      index: '',
      value: [],
    },
  };
  return picklistMappingFormEntity;
}

export function mapPicklistMappingFormEntityToDBEntity(picklistMappingFormEntity) {
  const picklistMappingDBEntity = { ...picklistMappingFormEntity, mappingTable: picklistMappingFormEntity.options };
  delete picklistMappingDBEntity.numberOfPicklists;
  delete picklistMappingDBEntity.options;
  delete picklistMappingDBEntity.optionsForm;
  return picklistMappingDBEntity;
}
